import api from '@/api/api'

export default {
    async fetchBy(params) {
        try {
            const resp = await api.get(`/api/district/import-log-results`, { params })

            return resp.data
        } catch (err) {
            throw 'Error fetching import logs'
        }
    },
}
